module.exports = __webpack_public_path__ + "img/chat.73fd7e3e.svg";